import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, limit, orderBy, query, Timestamp, updateDoc, where } from "firebase/firestore";
import { db, storage } from "./firebase";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";


export const queryNamesAllMembers = async (setData) => {
    const q = query(collection(db, "members"), orderBy("type", "asc"), orderBy("index", 'asc'));
    const querySnapshot = await getDocs(q);
    let members = {"-": "-"};
    querySnapshot.forEach((doc) => {
        const name = `[${doc.data().index}] ${doc.data().firstname ? `${doc.data().firstname} ${doc.data().lastname}` : doc.data().sgname}`;
        members = {...members, [doc.id]: name }
    });
    setData(members)
}

export const fetchMemberByID = async (id) => {
    const docRef = doc(db, "members", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        const { 
            hidden, ownlanguage, nationality, type, email, 
            shortDescription, description, education, fields, 
            links, publications, awards, professionalServices, 
        } = docSnap.data();
        return {
            hidden: hidden === undefined ? false : hidden, ownlanguage, nationality, type: type.toString(), email, 
            shortDescription, description, education, fields, 
            links, publications, awards, professionalServices, 
        }
    }
}

export const fetchMemberImageURL = async (id) => {
    const docRef = doc(db, "members", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        console.log(docSnap.data().img)
        return docSnap.data().img;
    }
    else {
        return ""
    }
}

export const getHighestIndex = async (type) => {
    const q = query(collection(db, "members"), where("type", "==", type), orderBy("index", "desc"), limit(1));
    const querySnapshot = await getDocs(q);
    if (!querySnapshot.empty) {
        const highestDoc = querySnapshot.docs[0];
        const highestValue = highestDoc.data().index;
        return highestValue;
    } else {
        console.log("Collection is empty");
        return 0;
    }
}

export const addMember = async ({...data}) => {

    // title, firstname, lastname, sgname, ownlanguage, nationality, type, email, shortDescription
    const type = parseInt(data.type);
    const highestIndex = await getHighestIndex(type);
    const docRef = await addDoc(collection(db, "members"), {
        ...data, 
        type,
        description: "",
        education: [],
        fields: [],
        links: [],
        publications: [],
        awards: [],
        professionalServices: [],
        index: highestIndex + 1,
        createAt: Timestamp.now(),
        timestamp: Timestamp.now(),
        hidden: true,
    })
    return docRef.id;
}

export const editMember = async (id, data) => {
    const updateData = {
        ...data,
        type: parseInt(data.type),
        timestamp: Timestamp.now()
    };
    const docRef = doc(db, "members", id);
    await updateDoc(docRef, updateData);
}

export const deleteMember = async (id) => {
    await deleteDoc(doc(db, "members", id));
    alert(`Document with id ${id} deleted successfully`);
}

export const editMemberImage = async (id, data) => {
    const { img } = data;
    const storageRef = ref(storage, `members/${id}`);
    await uploadBytes(storageRef, img);

    const url = await getDownloadURL(storageRef);
    const docRef = doc(db, "members", id);
    await updateDoc(docRef, { img: url });
    console.log(`Image for document ${id} updated successfully.`);
}